import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDateYYYYMMDD, createDateFromYYYYMMDDHyphen } from "@icarius-utils/date";
import { createMyPeopleScheduleAction, getMyPeopleScheduleAction } from "../actions";
import {
    getIsLoading,
    getWorkplaces,
    getTurns,
    getEmployees,
    getShifts,
    getSchedules,
    getOpenCalendars,
} from "../selectors";

const useMyPeopleSchedule = (employeeCode) => {
    const dispatch = useDispatch();
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        dispatch(getMyPeopleScheduleAction(employeeCode));
    }, [dispatch, employeeCode]);

    const handleSave = async (data) => {
        const dataToSend = data
            .filter(
                (item) => item.type === "exception" || item.type === "extraAuthorized" || item.type.includes("request")
            )
            .map((item) => {
                const startDate =
                    typeof item.start === "object" ? item.start : createDateFromYYYYMMDDHyphen(item.start);
                return {
                    resource: item.resource,
                    scheduleId: item.scheduleId,
                    start: formatDateYYYYMMDD(startDate),
                    time: item.timeAlreadyAuth,
                    title: item.title,
                    type: item.type,
                };
            });

        dispatch(createMyPeopleScheduleAction({ data: dataToSend })).then(
            (res) => res?.status === 200 && setHasChanges(false)
        );
    };

    const isLoading = useSelector(getIsLoading);
    const workplaces = useSelector(getWorkplaces);
    const turns = useSelector(getTurns);
    const employees = useSelector(getEmployees);
    const shifts = useSelector(getShifts);
    const schedules = useSelector(getSchedules);
    const openCalendars = useSelector(getOpenCalendars);

    return {
        handleSave,
        isLoading,
        workplaces,
        turns,
        employees,
        shifts,
        schedules,
        openCalendars,
        setHasChanges,
        hasChanges,
    };
};

export default useMyPeopleSchedule;
